








































































































































































































































































































import EventBus from '@/helpers/event-bus'
import DisplayItem from './DisplayItem.vue'
import PromisedImage from './PromisedImage.vue'
import Modal from './Modal.vue'
import ProductImage from '@/types/ProductImage'
import LocalizedObjectAnnotation from '@/types/LocalizedObjectAnnotation'
import scaleDimensions from '@/helpers/scale-dimensions'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import addFontAwesomeIcon from '@/helpers/add-font-awesome-icon'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

addFontAwesomeIcon(faSpinner)

@Component({ components: { DisplayItem, PromisedImage, Modal } })
export default class ImageGalleryItem extends Vue {
	private EventBus: typeof EventBus = EventBus
	public src: Promise<ImageData> = null

	private dropdownOpen: boolean = false
	private regenerateOccurrences = true
	private replacingImage = false

	@Prop({ type: Boolean, default: true })
	readonly rounded: boolean

	@Prop({ type: Object, required: true })
	readonly image: ProductImage

	@Prop({ type: String, default: 'li' })
	readonly element: string

	@Prop({ type: Boolean, default: false })
	readonly showUncategorize: boolean

	@Prop({ type: Boolean, default: true })
	readonly showDelete: boolean
	@Prop({ type: Boolean, default: true })
	readonly showOptions: boolean

	@Prop({ type: Boolean, default: false })
	readonly showReannotate: boolean

	@Prop({ type: Boolean, default: false })
	readonly showUsePreset: boolean

	private showingBoundingBoxDefiner = false
	private definedBoundingBox = {
		top: 0.25,
		right: 0.75,
		bottom: 0.75,
		left: 0.25
	}

	created() {
		this.resetSource()
	}

	mounted() {
		document.addEventListener('click', this.onDocumentClick, true)
		if (
			this.image.objects.length &&
			this.image.objects[0].mid === 'custom'
		) {
			this.definedBoundingBox = {
				top: this.image.objects[0].boundingPoly.normalizedVertices[0].y,
				left: this.image.objects[0].boundingPoly.normalizedVertices[0]
					.x,
				bottom: this.image.objects[0].boundingPoly.normalizedVertices[2]
					.y,
				right: this.image.objects[0].boundingPoly.normalizedVertices[2]
					.x
			}
			this.showingBoundingBoxDefiner = true
		}
	}

	beforeDestroy() {
		document.removeEventListener('click', this.onDocumentClick, true)
	}

	@Watch('image')
	resetSource() {
		this.src = this.image.image.src
	}

	getImageObjectPosition(obj: LocalizedObjectAnnotation) {
		if (obj.mid === '') {
			return 'display:none;'
		}

		const padding = this.$settings.gallery.boundingBoxPadding

		const top = Math.max(
			0,
			(obj.boundingPoly.normalizedVertices[0].y || 0) - padding
		)
		const left = Math.max(
			0,
			(obj.boundingPoly.normalizedVertices[0].x || 0) - padding
		)
		const right = Math.min(
			1,
			1 - ((obj.boundingPoly.normalizedVertices[2].x || 0) + padding)
		)
		const bottom = Math.min(
			1,
			1 - ((obj.boundingPoly.normalizedVertices[2].y || 0) + padding)
		)

		return `
			top: ${top * 100}%;
			left: ${left * 100}%;
			right: ${right * 100}%;
			bottom: ${bottom * 100}%;
			padding: ${top && left ? padding * 100 : 2}%;
			${this.$refs.image && this.$refs.imageLoaded ? '' : 'display:none;'}
		`
	}

	clearCache() {
		this.$store.commit('images/CLEAR_CACHE', this.image)
		this.dropdownOpen = false
	}

	usePreset() {
		this.dropdownOpen = false
		this.$emit('use-preset', this.image)
	}

	showBoundingBoxDefiner() {
		this.$store.commit('images/UPDATE_IMAGE', {
			id: this.image.id,
			categories: [this.image.category, this.image.subCategory]
		})

		this.$store.commit('images/REMOVE_BOUNDING_BOX', this.image.id)
		this.$store.commit('images/ADD_BOUNDING_BOX', this.image.id)
		this.updateBoundingBox()

		this.showingBoundingBoxDefiner = true
	}

	hideBoundingBoxDefiner() {
		this.$store.commit('images/REMOVE_BOUNDING_BOX', this.image.id)

		this.showingBoundingBoxDefiner = false
	}

	@Watch('definedBoundingBox.top')
	@Watch('definedBoundingBox.left')
	@Watch('definedBoundingBox.right')
	@Watch('definedBoundingBox.bottom')
	@Watch('definedBoundingBox')
	updateBoundingBox() {
		this.$store.commit('images/UPDATE_BOUNDING_BOX', {
			id: this.image.id,
			bb: this.definedBoundingBox
		})
	}

	reannotate() {
		this.$store.dispatch('images/REANNOTATE_IMAGE', this.image.id)
	}

	// Dropdown helpers
	private onDocumentClick(event: MouseEvent) {
		if (!this.dropdownOpen) {
			return
		}

		const button = this.$refs.optionsBtn as HTMLElement | undefined
		const menu = this.$refs.optionsMenu as HTMLElement | undefined
		const target = event.target as Node

		const insideButton = button ? button.contains(target) : false
		const insideMenu = menu ? menu.contains(target) : false

		if (!insideButton && !insideMenu) {
			this.dropdownOpen = false
		}
	}

	private toggleDropdown() {
		this.dropdownOpen = !this.dropdownOpen
		if (this.dropdownOpen) {
			this.positionMenu()
		}
	}

	private positionMenu() {
		const btn = this.$refs.optionsBtn as HTMLElement
		if (!btn) return
		const rect = btn.getBoundingClientRect()
		this.menuTop = rect.bottom + 4
		this.menuLeft = rect.left
	}

	private openReplace() {
		this.dropdownOpen = false
		this.resetReplaceState()

		this.$nextTick(() => {
			const modal = this.$refs.replaceModal as Modal | undefined
			if (modal) {
				modal.open()
			}
		})
	}

	private triggerFileSelect() {
		if (this.replacingImage) {
			return
		}

		const input = this.$refs.replaceInput as HTMLInputElement | undefined
		if (input) {
			input.click()
		}
	}

	private onReplaceAreaClick() {
		if (this.replacingImage) {
			return
		}

		this.triggerFileSelect()
	}

	private onReplaceDragOver() {
		if (this.replacingImage) {
			return
		}

		this.replaceModalDragging = true
	}

	private onReplaceDragLeave(e: DragEvent) {
		if (this.replacingImage) {
			return
		}

		if (e.currentTarget === e.target) {
			this.replaceModalDragging = false
		}
	}

	private async onReplaceDrop(e: DragEvent) {
		this.replaceModalDragging = false
		if (this.replacingImage) {
			return
		}
		const files = e.dataTransfer?.files
		if (!files || !files.length) {
			return
		}

		await this.processReplacementFile(files[0])
	}

	private resetReplaceState() {
		this.replaceModalDragging = false
		this.regenerateOccurrences = true
		this.replacingImage = false
		const input = this.$refs.replaceInput as HTMLInputElement | undefined
		if (input) {
			input.value = ''
		}
	}

	private closeReplaceModal() {
		if (this.replacingImage) {
			return
		}

		this.resetReplaceState()
		const modal = this.$refs.replaceModal as Modal | undefined
		if (modal) {
			modal.close()
		}
	}

	private cancelReplace() {
		if (this.replacingImage) {
			return
		}

		this.closeReplaceModal()
	}

	private async replaceImage(e: Event) {
		if (this.replacingImage) {
			return
		}

		const input = e.target as HTMLInputElement
		if (!input.files || !input.files.length) return
		const file = input.files[0]
		// reset input so the same file can be selected again later
		input.value = ''

		await this.processReplacementFile(file)
	}

	private async processReplacementFile(file: File) {
		if (this.replacingImage) {
			return
		}

		if (!file || !file.type.startsWith('image/')) {
			return
		}

		try {
			this.replacingImage = true
			this.replaceModalDragging = false

			const previousImageId = this.image.id
			const previousCategory = this.image.category
			const previousSubCategory = this.image.subCategory
			const previousOrder = this.image.order
			const shouldResetOccurrences = this.regenerateOccurrences

			const contents: string = await new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () => resolve(reader.result as string)
				reader.onerror = () => reject(reader.error)
				reader.readAsDataURL(file)
			})

			const newImage = ProductImage.fromFile({
				contents,
				name: file.name,
				type: file.type
			})

			this.$store.commit('images/PUSH_IMAGE', newImage)
			this.$store.commit('images/UPDATE_IMAGE', {
				id: newImage.id,
				categories: [previousCategory, previousSubCategory],
				categorizedManually: this.image.categorizedManually,
				order: previousOrder
			})
			await this.$store.dispatch('images/REANNOTATE_IMAGE', newImage.id)

			this.$store.commit('images/DELETE_IMAGE', previousImageId)

			if (shouldResetOccurrences) {
				await this.$store.dispatch(
					'platforms/RESET_IMAGE_OCCURRENCES_FOR_IMAGE',
					{
						previousImageId,
						newImageId: newImage.id
					}
				)
			}
		} finally {
			this.replacingImage = false
			this.closeReplaceModal()
		}
	}
}
